export const marioQuotes = [
  "it's a me",
  "it's a me, mario",
  "it's a me, luigi",
  'yoshi',
  "Mamma mia!",
  "let's-a-go!",
  'woohoo!'
]


  
  